import React, { useState, useEffect } from "react";
import "assets/css/Checkbox.min.css";

const Checkbox = ({
  value,
  label,
  defaultValue = false,
  onChange,
  theme,
  viewType = "checkbox",
  showValidationState,
  validationState,
}) => {
  const [checked, setChecked] = useState(defaultValue);

  useEffect(() => {
    if (onChange && typeof onChange === "function") {
      onChange(value, checked);
    }
  }, [checked]);

  const handleOnChange = (event) => {
    setChecked(event.target.checked);
  };

  const themes = {
    light: "light",
    dark: "dark",
  };

  const getTheme = (theme) => {
    if (themes.hasOwnProperty(theme)) {
      const actTheme = ` ${themes[theme].join(" ")}`;
      return actTheme;
    }
    return ` default`;
  };

  return (
    <>
      {viewType === "checkbox" && (
        <label
          className={`checkbox${
            showValidationState ? ` showValidationState` : ""
          }${!validationState ? ` error` : ""}${getTheme(theme)}`}
        >
          <input
            className="checkboxInput"
            type="checkbox"
            onChange={(event) => handleOnChange(event)}
          />
          <span className="checkboxCheckmark"></span>
          <span className="title">{label}</span>
        </label>
      )}

      {viewType === "button" && (
        <label
          className={`buttonTypeCheckbox${
            showValidationState ? ` showValidationState` : ""
          }${checked ? ` checked` : ""}`}
        >
          <input
            type="checkbox"
            onChange={(event) => handleOnChange(event)}
            checked={checked}
          />
          <div className="label">{label}</div>
        </label>
      )}
    </>
  );
};

export default Checkbox;
